
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("77Eyd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4dc64d520a243ee3$export$2e2bcd8739ae039);

var $hJCUd = parcelRequire("hJCUd");

var $6wlPy = parcelRequire("6wlPy");

var $jcw0u = parcelRequire("jcw0u");

var $g0NJu = parcelRequire("g0NJu");

var $3c4nq = parcelRequire("3c4nq");

var $l1yfo = parcelRequire("l1yfo");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4dc64d520a243ee3$export$2e2bcd8739ae039 = async ({ match: { params: params }, query: query }, { tenantContext: { baseUrl: baseUrl } })=>{
    const restQuery = (0, (/*@__PURE__*/$parcel$interopDefault($hJCUd)))((0, $6wlPy.default)((0, $3c4nq.queryFromUrl))(query), (0, $g0NJu.initialQuery));
    try {
        const data = await (0, $l1yfo.getPrefetchedData)(baseUrl, params && params.projectKey || '', restQuery);
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'prefetchComponents',
                packageName: 'jiraRouterResourcesProjectComponents'
            }
        });
        throw error;
    }
};

});
parcelRegister("hJCUd", function(module, exports) {

var $hlchF = parcelRequire("hlchF");

var $g7i7g = parcelRequire("g7i7g");

var $3KORh = parcelRequire("3KORh");

var $3dHKF = parcelRequire("3dHKF");
/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */ var $ce94d17a4ae582d5$var$defaultsDeep = $g7i7g(function(args) {
    args.push(undefined, $3KORh);
    return $hlchF($3dHKF, undefined, args);
});
module.exports = $ce94d17a4ae582d5$var$defaultsDeep;

});
parcelRegister("3KORh", function(module, exports) {

var $1m1GH = parcelRequire("1m1GH");

var $k0qYG = parcelRequire("k0qYG");
/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */ function $2bbd1e633373e9a1$var$customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
    if ($k0qYG(objValue) && $k0qYG(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        $1m1GH(objValue, srcValue, undefined, $2bbd1e633373e9a1$var$customDefaultsMerge, stack);
        stack['delete'](srcValue);
    }
    return objValue;
}
module.exports = $2bbd1e633373e9a1$var$customDefaultsMerge;

});


parcelRegister("6wlPy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c011c7ab8644dae0$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $dPSWJ = parcelRequire("dPSWJ");
const $c011c7ab8644dae0$var$fromUrlTransformerFactory = (transformer)=>(0, (/*@__PURE__*/$parcel$interopDefault($basmW)))([
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(params, (p)=>Array.isArray(p) ? p[0] : p),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>transformer(params)
    ]);
var $c011c7ab8644dae0$export$2e2bcd8739ae039 = $c011c7ab8644dae0$var$fromUrlTransformerFactory;

});

parcelRegister("g0NJu", function(module, exports) {

$parcel$export(module.exports, "initialQuery", () => $5db780a623eea3bd$export$8af7177c92ae79e3);

var $aBKog = parcelRequire("aBKog");

var $8GURO = parcelRequire("8GURO");
const $5db780a623eea3bd$export$8af7177c92ae79e3 = {
    orderField: (0, $8GURO.NAME),
    orderDirection: (0, $aBKog.ASC),
    page: 1,
    filter: ''
};

});
parcelRegister("aBKog", function(module, exports) {

$parcel$export(module.exports, "ASC", () => $3a24a09c42e46583$export$1dee026a19752d6b);
$parcel$export(module.exports, "DESC", () => $3a24a09c42e46583$export$b6abcf7fa1d94f65);
$parcel$export(module.exports, "ORDER_DIRECTION", () => $3a24a09c42e46583$export$543711d9afc9aac1);
const $3a24a09c42e46583$export$1dee026a19752d6b = 'ASC';
const $3a24a09c42e46583$export$b6abcf7fa1d94f65 = 'DESC';
const $3a24a09c42e46583$export$543711d9afc9aac1 = {
    [$3a24a09c42e46583$export$1dee026a19752d6b]: $3a24a09c42e46583$export$1dee026a19752d6b,
    [$3a24a09c42e46583$export$b6abcf7fa1d94f65]: $3a24a09c42e46583$export$b6abcf7fa1d94f65
};

});

parcelRegister("8GURO", function(module, exports) {

$parcel$export(module.exports, "NAME", () => $c276ed843b0e55a5$export$3c5e605ca7ade9f2);
$parcel$export(module.exports, "DESCRIPTION", () => $c276ed843b0e55a5$export$d44826c816b5619b);
$parcel$export(module.exports, "LEAD", () => $c276ed843b0e55a5$export$73dcda99369fd988);
$parcel$export(module.exports, "ISSUES", () => $c276ed843b0e55a5$export$1c62ab608c48125c);
$parcel$export(module.exports, "ORDER_FIELD", () => $c276ed843b0e55a5$export$55c82710eb02082c);
const $c276ed843b0e55a5$export$3c5e605ca7ade9f2 = 'NAME';
const $c276ed843b0e55a5$export$d44826c816b5619b = 'DESCRIPTION';
const $c276ed843b0e55a5$export$73dcda99369fd988 = 'LEAD';
const $c276ed843b0e55a5$export$1c62ab608c48125c = 'ISSUES';
const $c276ed843b0e55a5$export$55c82710eb02082c = {
    [$c276ed843b0e55a5$export$3c5e605ca7ade9f2]: $c276ed843b0e55a5$export$3c5e605ca7ade9f2,
    [$c276ed843b0e55a5$export$d44826c816b5619b]: $c276ed843b0e55a5$export$d44826c816b5619b,
    [$c276ed843b0e55a5$export$73dcda99369fd988]: $c276ed843b0e55a5$export$73dcda99369fd988,
    [$c276ed843b0e55a5$export$1c62ab608c48125c]: $c276ed843b0e55a5$export$1c62ab608c48125c
};

});


parcelRegister("3c4nq", function(module, exports) {

$parcel$export(module.exports, "queryFromUrl", () => $beb26f448099fc13$export$34bcc098502c2587);

var $aBKog = parcelRequire("aBKog");

var $8GURO = parcelRequire("8GURO");
const $beb26f448099fc13$var$getOrderEntity = (target, value, defaults)=>Object.values(target).includes(value) ? value : defaults;
const $beb26f448099fc13$export$dbde9a25ef92ab90 = (field)=>$beb26f448099fc13$var$getOrderEntity((0, $8GURO.ORDER_FIELD), field, (0, $8GURO.ORDER_FIELD).NAME);
const $beb26f448099fc13$export$d13e6a6b186c83d7 = (direction)=>$beb26f448099fc13$var$getOrderEntity((0, $aBKog.ORDER_DIRECTION), direction, (0, $aBKog.ORDER_DIRECTION).DESC);
const $beb26f448099fc13$export$aa86da1aa250e687 = (page)=>typeof Number(page) === 'number' && Number(page) >= 1 ? Number(page) : 1;
const $beb26f448099fc13$export$34bcc098502c2587 = ({ filter: filter, orderDirection: orderDirection, orderField: orderField, page: page })=>({
        filter: filter || '',
        orderDirection: $beb26f448099fc13$export$d13e6a6b186c83d7(orderDirection),
        orderField: $beb26f448099fc13$export$dbde9a25ef92ab90(orderField),
        page: $beb26f448099fc13$export$aa86da1aa250e687(page)
    });

});

parcelRegister("l1yfo", function(module, exports) {

$parcel$export(module.exports, "requestComponents", () => $5b80d05b85588877$export$7ec8ef4a312fa6eb);
$parcel$export(module.exports, "getPrefetchedData", () => $5b80d05b85588877$export$191a95ab818c6ef2);
$parcel$export(module.exports, "requestComponent", () => $5b80d05b85588877$export$f20b154a1c4c6494);

var $8xvPa = parcelRequire("8xvPa");

var $lfc7M = parcelRequire("lfc7M");

var $lEFJO = parcelRequire("lEFJO");

var $2EuXV = parcelRequire("2EuXV");

var $6z9Py = parcelRequire("6z9Py");

var $gJHvn = parcelRequire("gJHvn");

var $WCSZZ = parcelRequire("WCSZZ");
const $5b80d05b85588877$export$519b99feca126399 = (baseUrl, projectKey, startAt, maxResults, orderBy, filter)=>{
    const encodedQuery = encodeURIComponent(filter);
    const componentSourceParam = '&componentSource=auto';
    return `${baseUrl}/rest/api/2/project/${projectKey}/component?startAt=${startAt}&maxResults=${maxResults}&orderBy=${orderBy}&query=${encodedQuery}${componentSourceParam}`;
};
const $5b80d05b85588877$export$7ec8ef4a312fa6eb = async (baseUrl, projectKey, startAt = (0, $lfc7M.START_AT), maxResults = (0, $lfc7M.ITEMS_ON_PAGE), orderBy = (0, $lfc7M.ORDER), filter = (0, $lfc7M.FILTER))=>{
    const fullUrl = $5b80d05b85588877$export$519b99feca126399(baseUrl, projectKey, startAt, maxResults, orderBy, filter);
    const response = await fetch(fullUrl, (0, $lEFJO.createOptions)('GET'));
    const json = await response.json();
    if (!response.ok) throw await (0, $8xvPa.getErrorFromResponse)(response, 'Failed to fetch');
    const { values: values, total: total } = json;
    return (0, $WCSZZ.transformComponents)(values, total, baseUrl);
};
const $5b80d05b85588877$export$191a95ab818c6ef2 = (baseUrl, projectKey, query)=>{
    if (query) {
        const { orderDirection: orderDirection, orderField: orderField, filter: filter, page: page } = query;
        const orderBy = (0, $2EuXV.mapToOrderFetch)(orderField, orderDirection);
        const maxResults = (0, $lfc7M.ITEMS_ON_PAGE);
        const startAt = (page - 1) * maxResults;
        return $5b80d05b85588877$export$7ec8ef4a312fa6eb(baseUrl, projectKey, startAt, maxResults, orderBy, filter);
    }
    return $5b80d05b85588877$export$7ec8ef4a312fa6eb(baseUrl, projectKey);
};
const $5b80d05b85588877$export$2756a9db83f319ac = (id)=>`/rest/api/2/component/${id}`;
const $5b80d05b85588877$export$f20b154a1c4c6494 = async (state, id)=>{
    const baseUrl = (0, $6z9Py.getBaseUrl)(state);
    const fullUrl = `${baseUrl}${$5b80d05b85588877$export$2756a9db83f319ac(id)}`;
    const response = await fetch(fullUrl, (0, $lEFJO.createOptions)('GET'));
    const json = await response.json();
    if (response.ok) return {
        id: id,
        component: (0, $WCSZZ.transformComponentObj)(json, baseUrl)
    };
    throw (0, $gJHvn.getErrorFromResultJson)(json, response.status);
};

});
parcelRegister("8xvPa", function(module, exports) {

$parcel$export(module.exports, "getErrorFromResponse", () => $8065287d9cd7a779$export$7780d7826aafbede);

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $8065287d9cd7a779$export$7780d7826aafbede = async (response, defaultMessage)=>{
    let errorMessage = defaultMessage;
    try {
        const json = await response.json();
        const { errors: errors, errorMessages: errorMessages } = json;
        if (errors && Object.keys(errors).length) return (0, $eusud.transformValidationErrorFromServer)(json);
        errorMessage = errorMessages[0];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /**/ }
    return new (0, $jJZqs.default)(response.status, errorMessage);
};

});

parcelRegister("lfc7M", function(module, exports) {

$parcel$export(module.exports, "ITEMS_ON_PAGE", () => $1a5d2c525b8186bf$export$5364831c6b9eb7a3);
$parcel$export(module.exports, "PAGE", () => $1a5d2c525b8186bf$export$d3d35020fa5b54f0);
$parcel$export(module.exports, "FILTER", () => $1a5d2c525b8186bf$export$c1c49903035a02df);
$parcel$export(module.exports, "START_AT", () => $1a5d2c525b8186bf$export$5a3b37e8556e32de);
$parcel$export(module.exports, "ORDER", () => $1a5d2c525b8186bf$export$11e75bce9f7ea886);

var $fFsPq = parcelRequire("fFsPq");
const $1a5d2c525b8186bf$export$5364831c6b9eb7a3 = 25;
const $1a5d2c525b8186bf$export$d3d35020fa5b54f0 = 1;
const $1a5d2c525b8186bf$export$55c82710eb02082c = (0, $fFsPq.NAME);
const $1a5d2c525b8186bf$export$c1c49903035a02df = '';
const $1a5d2c525b8186bf$export$5a3b37e8556e32de = 0;
const $1a5d2c525b8186bf$export$11e75bce9f7ea886 = `+${(0, $fFsPq.ORDER_FIELDS)[$1a5d2c525b8186bf$export$55c82710eb02082c]}`;

});
parcelRegister("fFsPq", function(module, exports) {

$parcel$export(module.exports, "NAME", () => $7261733a8e91b3da$export$3c5e605ca7ade9f2);
$parcel$export(module.exports, "DESCRIPTION", () => $7261733a8e91b3da$export$d44826c816b5619b);
$parcel$export(module.exports, "LEAD", () => $7261733a8e91b3da$export$73dcda99369fd988);
$parcel$export(module.exports, "ISSUES", () => $7261733a8e91b3da$export$1c62ab608c48125c);
$parcel$export(module.exports, "ORDER_FIELDS", () => $7261733a8e91b3da$export$e6d6c3d190bf100b);
const $7261733a8e91b3da$export$3c5e605ca7ade9f2 = 'NAME';
const $7261733a8e91b3da$export$d44826c816b5619b = 'DESCRIPTION';
const $7261733a8e91b3da$export$73dcda99369fd988 = 'LEAD';
const $7261733a8e91b3da$export$1c62ab608c48125c = 'ISSUES';
const $7261733a8e91b3da$export$e6d6c3d190bf100b = {
    [$7261733a8e91b3da$export$3c5e605ca7ade9f2]: 'name',
    [$7261733a8e91b3da$export$d44826c816b5619b]: 'description',
    [$7261733a8e91b3da$export$73dcda99369fd988]: 'lead',
    [$7261733a8e91b3da$export$1c62ab608c48125c]: 'issueCount'
};

});


parcelRegister("lEFJO", function(module, exports) {

$parcel$export(module.exports, "createOptions", () => $33561caedbca9a6d$export$830e3e7c910fe629);
const $33561caedbca9a6d$export$830e3e7c910fe629 = (method, body)=>{
    const stringifiedBody = body ? JSON.stringify(body) : undefined;
    return {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        method: method,
        body: stringifiedBody
    };
};

});

parcelRegister("2EuXV", function(module, exports) {

$parcel$export(module.exports, "mapToOrderFetch", () => $86ae40210e05d826$export$6236a5c184fedc41);

var $aBKog = parcelRequire("aBKog");

var $8GURO = parcelRequire("8GURO");
const $86ae40210e05d826$export$cab2635bfaf51f49 = {
    [(0, $8GURO.NAME)]: 'name',
    [(0, $8GURO.DESCRIPTION)]: 'description',
    [(0, $8GURO.LEAD)]: 'lead',
    [(0, $8GURO.ISSUES)]: 'issueCount'
};
const $86ae40210e05d826$export$6236a5c184fedc41 = (orderField, orderDirection)=>(orderDirection === (0, $aBKog.DESC) ? '-' : '+') + $86ae40210e05d826$export$cab2635bfaf51f49[orderField];

});

parcelRegister("6z9Py", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $0c045fe856c36469$export$f654b28f82155665);
$parcel$export(module.exports, "isAdmin", () => $0c045fe856c36469$export$fc970ed23da99565);
$parcel$export(module.exports, "getLocale", () => $0c045fe856c36469$export$180605366c04f0cd);
const $0c045fe856c36469$export$f654b28f82155665 = (state)=>state.context.baseUrl;
const $0c045fe856c36469$export$fc970ed23da99565 = (state)=>state.context.isAdmin;
const $0c045fe856c36469$export$180605366c04f0cd = (state)=>state.context.locale;

});

parcelRegister("gJHvn", function(module, exports) {

$parcel$export(module.exports, "ComponentValidationError", () => $62103a3611ca0393$export$2a0a959ca186c5a2);
$parcel$export(module.exports, "getErrorFromResultJson", () => $62103a3611ca0393$export$f94105122c76865e);

var $jJZqs = parcelRequire("jJZqs");
class $62103a3611ca0393$export$2a0a959ca186c5a2 extends Error {
    constructor(message, errors){
        super(message);
        this.errors = errors || {};
    }
}
const $62103a3611ca0393$export$f94105122c76865e = (resultJson, status)=>{
    const errors = resultJson.errors;
    if (errors && (errors.name || errors.componentLead)) return new $62103a3611ca0393$export$2a0a959ca186c5a2('', {
        name: resultJson.errors.name,
        componentLead: resultJson.errors.componentLead
    });
    const errorMessage = resultJson.errorMessages && resultJson.errorMessages[0];
    return new (0, $jJZqs.default)(status, errorMessage);
};

});

parcelRegister("WCSZZ", function(module, exports) {

$parcel$export(module.exports, "transformComponentObj", () => $cefaff5f214f9f06$export$f505eac0336ab290);
$parcel$export(module.exports, "transformComponents", () => $cefaff5f214f9f06$export$67cf173cea018455);
const $cefaff5f214f9f06$var$transformLead = (user, baseUrl)=>({
        displayName: user.displayName,
        key: user.key,
        active: user.active,
        accountId: user.accountId,
        avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
        // from PK - I could not see this code being used anywhere. Hence not updating to new url.
        profileUrl: `${baseUrl}/jira/people/${user.accountId}`
    });
const $cefaff5f214f9f06$export$f505eac0336ab290 = (item, baseUrl)=>{
    const { name: name, description: description, assigneeType: assigneeType, lead: lead, componentBean: componentBean } = item;
    const { ari: ari, metadata: metadata } = componentBean ?? {};
    return {
        ari: ari,
        metadata: metadata,
        name: name,
        description: description,
        issueCount: item.issueCount ? item.issueCount : 0,
        defaultAssignee: assigneeType,
        lead: lead ? $cefaff5f214f9f06$var$transformLead(lead, baseUrl) : undefined
    };
};
const $cefaff5f214f9f06$export$79ccea7e11af4b35 = (item, baseUrl)=>({
        [item.id]: $cefaff5f214f9f06$export$f505eac0336ab290(item, baseUrl)
    });
const $cefaff5f214f9f06$export$67cf173cea018455 = (components, total, baseUrl)=>{
    const list = components.map((i)=>i.id);
    const listAri = components// Typesafe way to filter out undefined values.
    // Theoretically if global components are turned on, we will _only_ get back components with ARIs.
    // But to keep things happy with Typescript we need to handle undefined case as well.
    .flatMap(({ componentBean: componentBean })=>componentBean?.ari ? [
            componentBean?.ari
        ] : []);
    const byId = Object.assign({}, ...components.map((component)=>$cefaff5f214f9f06$export$79ccea7e11af4b35(component, baseUrl)));
    return {
        byId: byId,
        list: list,
        listAri: listAri,
        total: total
    };
};

});




//# sourceMappingURL=async-resource-projects-components.80fa7cf6.js.map
